import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import routes from 'common/routes/index';
import Gate from 'components/auth/Gate';
import { consumeVoluntaryLogout } from 'common/utils/general';

function Authenticated({ allowedRoles, children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);

  // Payment listener is now managed globally in RouterContent (router/index.js)
  // Removed duplicate subscription from here to prevent conflicts

  useEffect(() => {
    if (!user || Object.keys(user).length === 0) {
      // Salida VOLUNTARIA: al login limpio. Si se colgara el `?redirect=`, la siguiente cuenta
      // que iniciara sesión en esa misma URL aterrizaría donde quedó la anterior (Términos y
      // condiciones, típicamente) en lugar de en su propio inicio.
      if (consumeVoluntaryLogout()) {
        navigate(routes.login.path, { replace: true });
        return;
      }

      // Sesión caducada: aquí el destino SÍ se preserva (p. ej. un enlace de correo a
      // /payment-history) para volver tras el login. Solo rutas internas (open-redirect safe).
      // `replace: true` también aquí: mandar al login APILANDO historial hacía que el botón atrás
      // devolviera a la ruta protegida, que volvía a expulsar al login, y así una y otra vez. Eso
      // es lo que se percibía como "entra y sale". El destino se sigue guardando en `?redirect=`,
      // que es lo que de verdad hace falta para volver luego.
      const target = `${location.pathname}${location.search}`;
      navigate(
        target && target !== '/'
          ? `${routes.login.path}?redirect=${encodeURIComponent(target)}`
          : routes.login.path,
        { replace: true }
      );
    }
  }, [navigate, user, location.pathname, location.search]);

  return <Gate allowedRoles={allowedRoles}>{children}</Gate>;
}

Authenticated.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.element.isRequired
};

export default Authenticated;
